import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const email = urlParams.get("email");

    try {
      const data = JSON.stringify({
        email,
        password,
        password_confirmation: confirmPassword,
        token,
      });

      const response = await axios.post("https://hbmdijital.online/api/password/reset", data, {
        headers: {
          'Content-Type': 'application/json', // Ensure the correct content type is set
        },
      });

      alert("La réinitialisation du mot de passe a réussi.");
      navigate("/login"); // Redirect to login page after successful reset
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.message || "La r�initialisation du mot de passe a �chou�.";
        alert(errorMessage);
      } else if (error.request) {
        alert("Aucune r�ponse du serveur.");
      } else {
        alert("Une erreur est survenue.");
      }
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
        <h2 className="text-center mb-3">R&eacute;initialiser le mot de passe.</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="Nouveau mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="Confirmez le mot de passe"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" 
  style={{ backgroundColor: "#2c5a78", color: "white" }}

className="btn w-100">R&eacute;initialiser le mot de passe</button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
